import React, { useEffect, useState } from "react";
import LoginLeftSection from "./login/LoginLeftSection";
import LoginRightSection from "./login/LoginRightSection";
import WebUtils from "./utils/WebUtils";
import { getInterviewDataApi } from "../api";
import { useLocation } from "react-router-dom";
import Loader from "./Loader";

function Login({setWhiteLabelingObject}) {
  const [loading, setLoading] = useState(false);
  const [interviewData, setInterviewData] = useState(null);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const loginQuery = queryParams.get("q");

  const decodeValidate = (value) => {
    if (value === null) {
      return null;
    }
    try {
      return atob(value);
    } catch (error) {
      // console.error("Failed to decode login query:", error);
      return null; // Or handle it in a way that suits your application
    }
  };
  let decodedLoginQuery = decodeValidate(loginQuery);

  const params = {};
  if (decodedLoginQuery) {
    const paramsArray = decodedLoginQuery.split("&");

    paramsArray.forEach((param) => {
      const [key, value] = param.split("=");
      params[key] = value;
    });
  }

  const interviewId = params.interviewId;
  const passcode = params.passcode;
  const userRole = params.userRole;
  const interviewType = params.interviewType;

  const loginFormObj = {
    interviewId,
    passcode,
    userRole,
    interviewType,
  };
  const getBasicInfo = () => {
    setLoading(true);
    const url = `${getInterviewDataApi}?interviewId=${interviewId}&interviewType=${interviewType}`;

    WebUtils.httpOperations(url, {}, "GET", true)
      .then((result) => {
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setLoading(false);
          setInterviewData(result.data.data);
          setWhiteLabelingObject(result?.data?.data)
        } else if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "not_found"
        ) {
          setLoading(false);
          // setInterviewData(result.data.data);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

 
  useEffect(() => {
    if (decodedLoginQuery) {
      getBasicInfo();
    }
  }, [decodedLoginQuery]);

  return (
    <>
      {loading && <Loader />}
      {!loading && (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-y-6 gap-x-3 py-12 lg:py-5 w-full sm:w-[80%] m-auto">
          <LoginLeftSection
            interviewData={interviewData}
            loginQuery={loginQuery}
            decodedLoginQuery={decodedLoginQuery}
            loginFormObj={loginFormObj}
          />
          <LoginRightSection
            loginFormObj={loginFormObj}
            interviewData={interviewData}
            loginQuery={loginQuery}
          />
        </div>
      )}
    </>
  );
}

export default Login;
